/* tslint:disable */
/* eslint-disable */
/**
 * DIV.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LookupItemDto
 */
export interface LookupItemDto {
    /**
     * 
     * @type {string}
     * @memberof LookupItemDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof LookupItemDto
     */
    name: string | null;
}

/**
 * Check if a given object implements the LookupItemDto interface.
 */
export function instanceOfLookupItemDto(value: object): value is LookupItemDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function LookupItemDtoFromJSON(json: any): LookupItemDto {
    return LookupItemDtoFromJSONTyped(json, false);
}

export function LookupItemDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): LookupItemDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
    };
}

export function LookupItemDtoToJSON(json: any): LookupItemDto {
    return LookupItemDtoToJSONTyped(json, false);
}

export function LookupItemDtoToJSONTyped(value?: LookupItemDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
    };
}

